var envConstPS = `
vec3 processEnvironment(vec3 color) {
		return color;
}
`;

export { envConstPS as default };
